// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.
//
// For debugging: the file is generated via scripts/pipelines/generate_frontend/generate_frontend.py

/* eslint-disable import-x/order */

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

import {AGGREGATE_DATASET_STEP_SHAPES} from './generated-step-shapes/AggregateDataset';
import {ANOVA_STEP_SHAPES} from './generated-step-shapes/Anova';
import {BIN_DATA_STEP_SHAPES} from './generated-step-shapes/BinData';
import {BOLTZ2_STEP_SHAPES} from './generated-step-shapes/Boltz2';
import {BOLTZGEN_STEP_SHAPES} from './generated-step-shapes/Boltzgen';
import {BOLTZGEN_SUCCESS_STEP_SHAPES} from './generated-step-shapes/BoltzgenSuccess';
import {CHAI1_STEP_SHAPES} from './generated-step-shapes/Chai1';
import {CHART_VIEW_STEP_SHAPES} from './generated-step-shapes/ChartView';
import {COMPUTED_COLUMN_STEP_SHAPES} from './generated-step-shapes/ComputedColumn';
import {CONNECTION_DATA_DATASET_STEP_SHAPES} from './generated-step-shapes/ConnectionDataDataset';
import {CONVERT_ASM_TO_CSV_STEP_SHAPES} from './generated-step-shapes/ConvertAsmToCsv';
import {CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT_STEP_SHAPES} from './generated-step-shapes/ConvertFileToDatasetWithDataEntryAssistant';
import {CONVERT_JSON_TO_DATASET_STEP_SHAPES} from './generated-step-shapes/ConvertJsonToDataset';
import {CONVERT_OPENFOLD2_OUTPUT_STEP_SHAPES} from './generated-step-shapes/ConvertOpenfold2Output';
import {CONVERT_TO_ASM_STEP_SHAPES} from './generated-step-shapes/ConvertToAsm';
import {CREATE_DATASET_FROM_FILE_STEP_SHAPES} from './generated-step-shapes/CreateDatasetFromFile';
import {CREATE_PROCEDURE_DATASET_STEP_SHAPES} from './generated-step-shapes/CreateProcedureDataset';
import {DATA_CATALOG_DATASET_STEP_SHAPES} from './generated-step-shapes/DataCatalogDataset';
import {DATA_CATALOG_FILE_STEP_SHAPES} from './generated-step-shapes/DataCatalogFile';
import {DATA_CATALOG_FILES_STEP_SHAPES} from './generated-step-shapes/DataCatalogFiles';
import {DATASET_VIEW_STEP_SHAPES} from './generated-step-shapes/DatasetView';
import {DEFINE_TEMPLATE_VARIABLES_STEP_SHAPES} from './generated-step-shapes/DefineTemplateVariables';
import {EXPERIMENT_OPTIMIZATION_BOOTSTRAP_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationBootstrap';
import {EXPERIMENT_OPTIMIZATION_CLEAN_DATA_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationCleanData';
import {EXPERIMENT_OPTIMIZATION_EXPLANATION_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationExplanation';
import {EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationGenerateSearchSpace';
import {EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationPosteriorSummary';
import {EXPERIMENT_OPTIMIZATION_RECOMMENDATION_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationRecommendation';
import {EXPERIMENT_OPTIMIZATION_TRAINING_STEP_SHAPES} from './generated-step-shapes/ExperimentOptimizationTraining';
import {EXPLORATORY_DATA_ANALYSIS_STEP_SHAPES} from './generated-step-shapes/ExploratoryDataAnalysis';
import {EXPORT_DATA_CATALOG_DATASET_STEP_SHAPES} from './generated-step-shapes/ExportDataCatalogDataset';
import {EXPORT_DATA_CATALOG_FILE_STEP_SHAPES} from './generated-step-shapes/ExportDataCatalogFile';
import {EXTRACT_DATA_FRAME_VALUE_STEP_SHAPES} from './generated-step-shapes/ExtractDataFrameValue';
import {EXTRACT_OR_REMOVE_LINES_STEP_SHAPES} from './generated-step-shapes/ExtractOrRemoveLines';
import {FILTER_DATASET_STEP_SHAPES} from './generated-step-shapes/FilterDataset';
import {FIND_AND_REPLACE_STEP_SHAPES} from './generated-step-shapes/FindAndReplace';
import {FLAG_ROWS_STEP_SHAPES} from './generated-step-shapes/FlagRows';
import {GENERATE_BOLTZ_YAML_STEP_SHAPES} from './generated-step-shapes/GenerateBoltzYaml';
import {GENERATE_BOLTZGEN_YAML_STEP_SHAPES} from './generated-step-shapes/GenerateBoltzgenYaml';
import {GENERATE_FASTA_STEP_SHAPES} from './generated-step-shapes/GenerateFasta';
import {GENERATE_OPENFOLD2_JSON_STEP_SHAPES} from './generated-step-shapes/GenerateOpenfold2Json';
import {HIDE_COLUMNS_STEP_SHAPES} from './generated-step-shapes/HideColumns';
import {IMPORT_SCRATCH_FILE_STEP_SHAPES} from './generated-step-shapes/ImportScratchFile';
import {INITIALIZE_DATASET_STEP_SHAPES} from './generated-step-shapes/InitializeDataset';
import {INTERPOLATE_MARKDOWN_STEP_SHAPES} from './generated-step-shapes/InterpolateMarkdown';
import {JOIN_STEP_SHAPES} from './generated-step-shapes/Join';
import {LAYOUT_STEP_SHAPES} from './generated-step-shapes/Layout';
import {LOOK_UP_STEP_SHAPES} from './generated-step-shapes/LookUp';
import {MAP_COLUMNS_STEP_SHAPES} from './generated-step-shapes/MapColumns';
import {MAP_JSON_TO_DATASETS_AND_FILES_STEP_SHAPES} from './generated-step-shapes/MapJsonToDatasetsAndFiles';
import {NOTEBOOK_TABLE_DATASET_STEP_SHAPES} from './generated-step-shapes/NotebookTableDataset';
import {OPENFOLD2_STEP_SHAPES} from './generated-step-shapes/Openfold2';
import {PARAMETER_OPTIMIZATION_CONFIGURATION_STEP_SHAPES} from './generated-step-shapes/ParameterOptimizationConfiguration';
import {PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION_STEP_SHAPES} from './generated-step-shapes/ParameterOptimizationDatasetConfiguration';
import {PARAMETER_OPTIMIZATION_MODELING_STEP_SHAPES} from './generated-step-shapes/ParameterOptimizationModeling';
import {PARAMETER_OPTIMIZATION_PREDICTION_STEP_SHAPES} from './generated-step-shapes/ParameterOptimizationPrediction';
import {PIVOT_DATASET_STEP_SHAPES} from './generated-step-shapes/PivotDataset';
import {PLATE_SCHEMA_DATASET_STEP_SHAPES} from './generated-step-shapes/PlateSchemaDataset';
import {PROCEDURE_RUN_DATA_FRAMES_STEP_SHAPES} from './generated-step-shapes/ProcedureRunDataFrames';
import {PROMOTE_DATASET_STEP_SHAPES} from './generated-step-shapes/PromoteDataset';
import {REGISTRY_SCHEMA_DATASET_STEP_SHAPES} from './generated-step-shapes/RegistrySchemaDataset';
import {REGRESSION_STEP_SHAPES} from './generated-step-shapes/Regression';
import {REGRESSION_INTERPOLATION_STEP_SHAPES} from './generated-step-shapes/RegressionInterpolation';
import {RENAME_COLUMNS_STEP_SHAPES} from './generated-step-shapes/RenameColumns';
import {REORDER_COLUMNS_STEP_SHAPES} from './generated-step-shapes/ReorderColumns';
import {RETYPE_COLUMNS_STEP_SHAPES} from './generated-step-shapes/RetypeColumns';
import {RUN_HIGHRES_PROTOCOL_STEP_SHAPES} from './generated-step-shapes/RunHighresProtocol';
import {SAVE_STRUCTURE_PREDICTION_STEP_SHAPES} from './generated-step-shapes/SaveStructurePrediction';
import {SAVE_TO_RESULTS_STEP_SHAPES} from './generated-step-shapes/SaveToResults';
import {SEND_TO_CONNECTION_STEP_SHAPES} from './generated-step-shapes/SendToConnection';
import {SEND_TO_DOCUMENT_STEP_SHAPES} from './generated-step-shapes/SendToDocument';
import {SORT_COLUMNS_STEP_SHAPES} from './generated-step-shapes/SortColumns';
import {T_TEST_STEP_SHAPES} from './generated-step-shapes/TTest';
import {TABLE_VIEW_STEP_SHAPES} from './generated-step-shapes/TableView';
import {TEMPLATE_INPUT_STEP_SHAPES} from './generated-step-shapes/TemplateInput';
import {TEST_ALL_CONFIGS_STEP_SHAPES} from './generated-step-shapes/TestAllConfigs';
import {THIRD_PARTY_STEP_SHAPES} from './generated-step-shapes/ThirdParty';
import {UNION_DATASETS_STEP_SHAPES} from './generated-step-shapes/UnionDatasets';
import {UNPIVOT_DATASET_STEP_SHAPES} from './generated-step-shapes/UnpivotDataset';
import {UPLOAD_CSV_DATASET_STEP_SHAPES} from './generated-step-shapes/UploadCsvDataset';
import {USER_DEFINED_FUNCTION_STEP_SHAPES} from './generated-step-shapes/UserDefinedFunction';
import {WINDOW_FUNCTIONS_STEP_SHAPES} from './generated-step-shapes/WindowFunctions';

export const PIPELINE_STEP_SHAPES = {
  [PipelineStepType.AGGREGATE_DATASET]: AGGREGATE_DATASET_STEP_SHAPES,
  [PipelineStepType.ANOVA]: ANOVA_STEP_SHAPES,
  [PipelineStepType.BIN_DATA]: BIN_DATA_STEP_SHAPES,
  [PipelineStepType.BOLTZ2]: BOLTZ2_STEP_SHAPES,
  [PipelineStepType.BOLTZGEN]: BOLTZGEN_STEP_SHAPES,
  [PipelineStepType.BOLTZGEN_SUCCESS]: BOLTZGEN_SUCCESS_STEP_SHAPES,
  [PipelineStepType.CHAI1]: CHAI1_STEP_SHAPES,
  [PipelineStepType.CHART_VIEW]: CHART_VIEW_STEP_SHAPES,
  [PipelineStepType.COMPUTED_COLUMN]: COMPUTED_COLUMN_STEP_SHAPES,
  [PipelineStepType.CONNECTION_DATA_DATASET]: CONNECTION_DATA_DATASET_STEP_SHAPES,
  [PipelineStepType.CONVERT_ASM_TO_CSV]: CONVERT_ASM_TO_CSV_STEP_SHAPES,
  [PipelineStepType.CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT]: CONVERT_FILE_TO_DATASET_WITH_DATA_ENTRY_ASSISTANT_STEP_SHAPES,
  [PipelineStepType.CONVERT_JSON_TO_DATASET]: CONVERT_JSON_TO_DATASET_STEP_SHAPES,
  [PipelineStepType.CONVERT_OPENFOLD2_OUTPUT]: CONVERT_OPENFOLD2_OUTPUT_STEP_SHAPES,
  [PipelineStepType.CONVERT_TO_ASM]: CONVERT_TO_ASM_STEP_SHAPES,
  [PipelineStepType.CREATE_DATASET_FROM_FILE]: CREATE_DATASET_FROM_FILE_STEP_SHAPES,
  [PipelineStepType.CREATE_PROCEDURE_DATASET]: CREATE_PROCEDURE_DATASET_STEP_SHAPES,
  [PipelineStepType.DATA_CATALOG_DATASET]: DATA_CATALOG_DATASET_STEP_SHAPES,
  [PipelineStepType.DATA_CATALOG_FILE]: DATA_CATALOG_FILE_STEP_SHAPES,
  [PipelineStepType.DATA_CATALOG_FILES]: DATA_CATALOG_FILES_STEP_SHAPES,
  [PipelineStepType.DATASET_VIEW]: DATASET_VIEW_STEP_SHAPES,
  [PipelineStepType.DEFINE_TEMPLATE_VARIABLES]: DEFINE_TEMPLATE_VARIABLES_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_BOOTSTRAP]: EXPERIMENT_OPTIMIZATION_BOOTSTRAP_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_CLEAN_DATA]: EXPERIMENT_OPTIMIZATION_CLEAN_DATA_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_EXPLANATION]: EXPERIMENT_OPTIMIZATION_EXPLANATION_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE]: EXPERIMENT_OPTIMIZATION_GENERATE_SEARCH_SPACE_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY]: EXPERIMENT_OPTIMIZATION_POSTERIOR_SUMMARY_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_RECOMMENDATION]: EXPERIMENT_OPTIMIZATION_RECOMMENDATION_STEP_SHAPES,
  [PipelineStepType.EXPERIMENT_OPTIMIZATION_TRAINING]: EXPERIMENT_OPTIMIZATION_TRAINING_STEP_SHAPES,
  [PipelineStepType.EXPLORATORY_DATA_ANALYSIS]: EXPLORATORY_DATA_ANALYSIS_STEP_SHAPES,
  [PipelineStepType.EXPORT_DATA_CATALOG_DATASET]: EXPORT_DATA_CATALOG_DATASET_STEP_SHAPES,
  [PipelineStepType.EXPORT_DATA_CATALOG_FILE]: EXPORT_DATA_CATALOG_FILE_STEP_SHAPES,
  [PipelineStepType.EXTRACT_DATA_FRAME_VALUE]: EXTRACT_DATA_FRAME_VALUE_STEP_SHAPES,
  [PipelineStepType.EXTRACT_OR_REMOVE_LINES]: EXTRACT_OR_REMOVE_LINES_STEP_SHAPES,
  [PipelineStepType.FILTER_DATASET]: FILTER_DATASET_STEP_SHAPES,
  [PipelineStepType.FIND_AND_REPLACE]: FIND_AND_REPLACE_STEP_SHAPES,
  [PipelineStepType.FLAG_ROWS]: FLAG_ROWS_STEP_SHAPES,
  [PipelineStepType.GENERATE_BOLTZ_YAML]: GENERATE_BOLTZ_YAML_STEP_SHAPES,
  [PipelineStepType.GENERATE_BOLTZGEN_YAML]: GENERATE_BOLTZGEN_YAML_STEP_SHAPES,
  [PipelineStepType.GENERATE_FASTA]: GENERATE_FASTA_STEP_SHAPES,
  [PipelineStepType.GENERATE_OPENFOLD2_JSON]: GENERATE_OPENFOLD2_JSON_STEP_SHAPES,
  [PipelineStepType.HIDE_COLUMNS]: HIDE_COLUMNS_STEP_SHAPES,
  [PipelineStepType.IMPORT_SCRATCH_FILE]: IMPORT_SCRATCH_FILE_STEP_SHAPES,
  [PipelineStepType.INITIALIZE_DATASET]: INITIALIZE_DATASET_STEP_SHAPES,
  [PipelineStepType.INTERPOLATE_MARKDOWN]: INTERPOLATE_MARKDOWN_STEP_SHAPES,
  [PipelineStepType.JOIN]: JOIN_STEP_SHAPES,
  [PipelineStepType.LAYOUT]: LAYOUT_STEP_SHAPES,
  [PipelineStepType.LOOK_UP]: LOOK_UP_STEP_SHAPES,
  [PipelineStepType.MAP_COLUMNS]: MAP_COLUMNS_STEP_SHAPES,
  [PipelineStepType.MAP_JSON_TO_DATASETS_AND_FILES]: MAP_JSON_TO_DATASETS_AND_FILES_STEP_SHAPES,
  [PipelineStepType.NOTEBOOK_TABLE_DATASET]: NOTEBOOK_TABLE_DATASET_STEP_SHAPES,
  [PipelineStepType.OPENFOLD2]: OPENFOLD2_STEP_SHAPES,
  [PipelineStepType.PARAMETER_OPTIMIZATION_CONFIGURATION]: PARAMETER_OPTIMIZATION_CONFIGURATION_STEP_SHAPES,
  [PipelineStepType.PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION]: PARAMETER_OPTIMIZATION_DATASET_CONFIGURATION_STEP_SHAPES,
  [PipelineStepType.PARAMETER_OPTIMIZATION_MODELING]: PARAMETER_OPTIMIZATION_MODELING_STEP_SHAPES,
  [PipelineStepType.PARAMETER_OPTIMIZATION_PREDICTION]: PARAMETER_OPTIMIZATION_PREDICTION_STEP_SHAPES,
  [PipelineStepType.PIVOT_DATASET]: PIVOT_DATASET_STEP_SHAPES,
  [PipelineStepType.PLATE_SCHEMA_DATASET]: PLATE_SCHEMA_DATASET_STEP_SHAPES,
  [PipelineStepType.PROCEDURE_RUN_DATA_FRAMES]: PROCEDURE_RUN_DATA_FRAMES_STEP_SHAPES,
  [PipelineStepType.PROMOTE_DATASET]: PROMOTE_DATASET_STEP_SHAPES,
  [PipelineStepType.REGISTRY_SCHEMA_DATASET]: REGISTRY_SCHEMA_DATASET_STEP_SHAPES,
  [PipelineStepType.REGRESSION]: REGRESSION_STEP_SHAPES,
  [PipelineStepType.REGRESSION_INTERPOLATION]: REGRESSION_INTERPOLATION_STEP_SHAPES,
  [PipelineStepType.RENAME_COLUMNS]: RENAME_COLUMNS_STEP_SHAPES,
  [PipelineStepType.REORDER_COLUMNS]: REORDER_COLUMNS_STEP_SHAPES,
  [PipelineStepType.RETYPE_COLUMNS]: RETYPE_COLUMNS_STEP_SHAPES,
  [PipelineStepType.RUN_HIGHRES_PROTOCOL]: RUN_HIGHRES_PROTOCOL_STEP_SHAPES,
  [PipelineStepType.SAVE_STRUCTURE_PREDICTION]: SAVE_STRUCTURE_PREDICTION_STEP_SHAPES,
  [PipelineStepType.SAVE_TO_RESULTS]: SAVE_TO_RESULTS_STEP_SHAPES,
  [PipelineStepType.SEND_TO_CONNECTION]: SEND_TO_CONNECTION_STEP_SHAPES,
  [PipelineStepType.SEND_TO_DOCUMENT]: SEND_TO_DOCUMENT_STEP_SHAPES,
  [PipelineStepType.SORT_COLUMNS]: SORT_COLUMNS_STEP_SHAPES,
  [PipelineStepType.T_TEST]: T_TEST_STEP_SHAPES,
  [PipelineStepType.TABLE_VIEW]: TABLE_VIEW_STEP_SHAPES,
  [PipelineStepType.TEMPLATE_INPUT]: TEMPLATE_INPUT_STEP_SHAPES,
  [PipelineStepType.TEST_ALL_CONFIGS]: TEST_ALL_CONFIGS_STEP_SHAPES,
  [PipelineStepType.THIRD_PARTY]: THIRD_PARTY_STEP_SHAPES,
  [PipelineStepType.UNION_DATASETS]: UNION_DATASETS_STEP_SHAPES,
  [PipelineStepType.UNPIVOT_DATASET]: UNPIVOT_DATASET_STEP_SHAPES,
  [PipelineStepType.UPLOAD_CSV_DATASET]: UPLOAD_CSV_DATASET_STEP_SHAPES,
  [PipelineStepType.USER_DEFINED_FUNCTION]: USER_DEFINED_FUNCTION_STEP_SHAPES,
  [PipelineStepType.WINDOW_FUNCTIONS]: WINDOW_FUNCTIONS_STEP_SHAPES
} as const satisfies Record<PipelineStepType, ReadonlyArray<PipelineStepShape>>;
